module.exports = __webpack_public_path__ + "img/04.f8b0a3f7.png";